import { formatEventName } from '../helpers';
const checkIfNewRelicIsValid = (newRelicInstance) => {
    return !!(
        newRelicInstance &&
        typeof newRelicInstance?.setCustomAttribute === 'function' &&
        typeof newRelicInstance?.addPageAction === 'function'
    );
};
class NewRelicAdapter {
    cmInstance;
    newRelicInstance = null;
    constructor(cmInstance) {
        this.cmInstance = cmInstance;
    }
    setSenderInstance(newRelicInstance) {
        this.newRelicInstance = newRelicInstance;
    }
    sendEvent({ eventName, payload }) {
        const newRelicInstance = this.resolveNewRelicInstance();
        if (checkIfNewRelicIsValid(newRelicInstance)) {
            let attributes = {
                value: payload?.measurement ?? 0,
            };
            if (payload?.customData) {
                attributes = { ...attributes, ...payload.customData };
            }
            newRelicInstance.addPageAction(
                formatEventName(eventName, this.cmInstance.namespace),
                attributes,
            );
        }
    }
    resolveNewRelicInstance() {
        if (this.newRelicInstance) {
            return this.newRelicInstance;
        } else if (typeof window?.newrelic === 'object') {
            return window.newrelic;
        }
        return null;
    }
}
export default NewRelicAdapter;
